"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import React from "react";
import { Subsidiary } from "../types";

interface SubsidiaryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (
    subsidiaryData: Omit<
      Subsidiary,
      "id" | "company_id" | "created_at" | "updated_at"
    >
  ) => void;
  subsidiary?: Subsidiary;
  title: string;
  isSaving?: boolean;
}

export function SubsidiaryModal({
  open,
  onOpenChange,
  onSave,
  subsidiary,
  title,
  isSaving = false
}: SubsidiaryModalProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = formData.get("name") as string;
    const location = formData.get("location") as string;

    onSave({
      name,
      location
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Name</Label>
            <Input
              id="name"
              name="name"
              defaultValue={subsidiary?.name}
              required
              disabled={isSaving}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="location">Standort</Label>
            <Input
              id="location"
              name="location"
              defaultValue={subsidiary?.location}
              required
              disabled={isSaving}
            />
          </div>
          <div className="flex justify-end">
            <Button type="submit" disabled={isSaving}>
              {isSaving ? "Speichern..." : "Speichern"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
